import React from 'react';
import { MenuItem } from '@mui/material';
import type { PatientIntakeFormState } from '../../../constants/patient';
import {
  disabilityMedicalCertOptions,
  intractableDiseaseCapOptions,
  medicalInsuranceCopayOptions,
  medicalInsuranceIncomeClassOptions,
  medicalInsuranceTypeOptions,
} from '../../../constants/patient';
import IntakeFormRow from '../IntakeFormRow';
import IntakeTextField from '../IntakeTextField';

type Props = {
  form: PatientIntakeFormState;
  patchForm: (p: Partial<PatientIntakeFormState>) => void;
};

const emptyMenuItem = <MenuItem value="">未選択</MenuItem>;

const MedicalInsuranceFields: React.FC<Props> = ({ form, patchForm }) => (
  <>
    <IntakeFormRow compact label="種類">
      <IntakeTextField
        select
        value={form.medicalInsuranceType}
        onChange={(e) =>
          patchForm({
            medicalInsuranceType: e.target.value as PatientIntakeFormState['medicalInsuranceType'],
          })
        }
      >
        {emptyMenuItem}
        {medicalInsuranceTypeOptions.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </IntakeTextField>
    </IntakeFormRow>
    <IntakeFormRow compact label="所得区分">
      <IntakeTextField
        select
        value={form.medicalInsuranceIncomeClass}
        onChange={(e) =>
          patchForm({
            medicalInsuranceIncomeClass: e.target
              .value as PatientIntakeFormState['medicalInsuranceIncomeClass'],
          })
        }
      >
        {emptyMenuItem}
        {medicalInsuranceIncomeClassOptions.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </IntakeTextField>
    </IntakeFormRow>
    <IntakeFormRow compact label="負担割合">
      <IntakeTextField
        select
        value={form.medicalInsuranceCopay}
        onChange={(e) =>
          patchForm({
            medicalInsuranceCopay: e.target.value as PatientIntakeFormState['medicalInsuranceCopay'],
          })
        }
      >
        {emptyMenuItem}
        {medicalInsuranceCopayOptions.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </IntakeTextField>
    </IntakeFormRow>
    <IntakeFormRow compact label="難病医療証 上限">
      <IntakeTextField
        select
        value={form.intractableDiseaseCap}
        onChange={(e) =>
          patchForm({
            intractableDiseaseCap: e.target.value as PatientIntakeFormState['intractableDiseaseCap'],
          })
        }
      >
        {emptyMenuItem}
        {intractableDiseaseCapOptions.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </IntakeTextField>
    </IntakeFormRow>
    <IntakeFormRow compact label="障害者医療証">
      <IntakeTextField
        select
        value={form.disabilityMedicalCert}
        onChange={(e) =>
          patchForm({
            disabilityMedicalCert: e.target
              .value as PatientIntakeFormState['disabilityMedicalCert'],
          })
        }
      >
        {emptyMenuItem}
        {disabilityMedicalCertOptions.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </IntakeTextField>
    </IntakeFormRow>
  </>
);

export default MedicalInsuranceFields;
